(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('header-search').forEach((header) => {
    const results = header.querySelector('predictive-search [slot="results"]');
    const input = header.querySelector('input[type="search"]');
    const status = header.querySelector('[data-lt-predictive-status]');
    if (!results || !input || !status) return;
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const terms = input.value.trim();
        if (!terms) { status.textContent = ''; return; }
        const noResults = results.querySelector('.predictive-search__no-results');
        if (noResults) { status.textContent = noResults.textContent.trim(); return; }
        const links = Array.from(results.querySelectorAll('a[href]')).filter((link) =>
          link.getClientRects().length && link.textContent.trim() && !link.closest('[hidden]')
        );
        const count = new Set(links.map((link) => link.getAttribute('href'))).size;
        const template = count === 1 ? status.dataset.templateOne : status.dataset.template;
        status.textContent = template.replace(/&quot;/g, '"').replace('[count]', String(count)).replace('[terms]', terms);
      }, 150);
    }).observe(results, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-previews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lt-gallery-previews')) {
    customElements.define('lt-gallery-previews', class extends HTMLElement {
      async connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        await customElements.whenDefined('scroll-carousel');
        if (!this.isConnected || signal.aborted) return;
        this.carousel = document.getElementById(this.getAttribute('aria-controls'));
        if (!this.carousel) return;
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.carousel.addEventListener('carousel:change', event => this.update(event.detail.cell), { signal });
        this.carousel.addEventListener('carousel:filter', () => this.update(), { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-preview-media-id]');
          if (!button || !this.contains(button)) return;
          const index = this.carousel.cells.findIndex(cell => cell.dataset.mediaId === button.dataset.previewMediaId);
          if (index < 0) return;
          this.carousel.select(index);
          this.carousel.setAttribute('tabindex', '0');
          this.carousel.focus({ preventScroll: true });
        }, { signal });
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      update(selectedCell = this.carousel.selectedCell) {
        const cells = this.carousel.cells;
        const selectedIndex = Math.max(0, cells.indexOf(selectedCell));
        const ordered = cells.slice(selectedIndex + 1).concat(cells.slice(0, selectedIndex));
        const images = ordered.filter(cell => cell.dataset.mediaType === 'image').slice(0, 2);
        const visibleIds = images.map(cell => cell.dataset.mediaId);
        this.buttons.forEach(button => {
          button.hidden = !visibleIds.includes(button.dataset.previewMediaId);
          button.style.order = visibleIds.indexOf(button.dataset.previewMediaId);
        });
        this.hidden = visibleIds.length === 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
